import FallbackErrorPage from './fallbackErrorPage.vue';
import FallbackEmpty from './fallbackEmpty.vue';
import { logException } from '@/sentry';
const isObjectEmpty = obj => Object.entries(obj).length === 0 && obj.constructor === Object;
const warn = msg => console.warn(msg);
// https://github.com/posva/vue-promised/blob/master/src/index.js
const convertVNodeArray = (h, wrapperTag, nodes) => {
  // for arrays and single text nodes
  if (nodes.length > 1 || !nodes[0].tag) {
    return h(wrapperTag, {}, nodes);
  }
  return nodes[0];
};
export default {
  name: 'ErrorBoundary',
  props: {
    fallBack: {
      type: [Object, Boolean],
      default: () => FallbackErrorPage
    },
    onError: {
      type: Function,
      default: null
    },
    params: {
      type: Object,
      default: () => ({})
    },
    stopPropagation: {
      type: Boolean,
      default: true
    },
    tag: {
      type: String,
      default: 'span'
    }
  },
  data() {
    return {
      err: '',
      info: '',
      hasError: null
    };
  },
  computed: {
    fallbackComponent() {
      return this.fallBack ? this.fallBack : FallbackEmpty;
    }
  },
  errorCaptured(err, vm, info = '') {
    this.hasError = true;
    this.err = err;
    this.info = info;
    this.element = vm.$vnode.tag;

    // Send error to Sentry
    logException(this.err, {
      level: 'fatal',
      tags: {
        boundary: true
      }
    });
    this.$emit('errorCaptured', {
      err,
      vm,
      info
    });
    if (this.onError) {
      this.onError(err, vm, info);
    }
    if (this.stopPropagation) {
      return false;
    }
  },
  render(h) {
    const fallback = this.fallbackComponent;
    const content = this.$slots.default;
    const isScoped = this.$scopedSlots.boundary;
    let scopedSlot;
    if (isScoped) {
      scopedSlot = this.$scopedSlots.boundary({
        hasError: this.hasError,
        err: this.err,
        info: this.info,
        element: this.element
      });
    }
    const fallbackOrScoped = isScoped ? scopedSlot : h(fallback, {
      props: {
        ...this.params,
        error: this.err,
        info: this.info,
        element: this.element
      }
    });
    if (this.hasError) {
      return Array.isArray(fallbackOrScoped) ? convertVNodeArray(h, this.tag, fallbackOrScoped) : fallbackOrScoped;
    }
    if (isScoped) {
      if (!this.$scopedSlots.boundary()) {
        warn('ErrorBoundary component must have child components.');
        return null;
      }
      return Array.isArray(scopedSlot) ? convertVNodeArray(h, this.tag, scopedSlot) : scopedSlot;
    }
    if (isObjectEmpty(this.$slots)) {
      warn('ErrorBoundary component must have child components.');
      return null;
    }
    return Array.isArray(content) ? convertVNodeArray(h, this.tag, content) : content;
  }
};